import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import { roledrp } from '../../Helper'
import moment from 'moment'

import { menumgmtApi,menumgmtmodelApi } from '../../../utils/AdminDashApi/MenuMgmtApi'
import { roleMgmtApi } from '../../../utils/AdminDashApi/RoleMgmtApi'
import { menuApi } from '../../../utils/AdminDashApi/MenuApi'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
const MenuCompmb = () => {
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")
  
 
  const [roleDrp,setRoledrp] = useState("")
  const handleShow = () => setShow2(true);

  const [activefrommod1,setactivefrommod1] = useState("")
  const [borderactivefrommod1,setborderactivefrommod1] = useState("")
  const [labelactivefrommod1,setlabelactivefrommod1] = useState("")

  const [activetomod1,setactivetomod1] = useState("")
  const [borderactivetomod1,setborderactivetomod1] = useState("")
  const [labelactivetomod1,setlabelactivetomod1] = useState("")

  const [activefrommod2,setactivefrommod2] = useState("")
  const [borderactivefrommod2,setborderactivefrommod2] = useState("")
  const [labelactivefrommod2,setlabelactivefrommod2] = useState("")

  const [activetomod2,setactivetomod2] = useState("")
  const [borderactivetomod2,setborderactivetomod2] = useState("")
  const [labelactivetomod2,setlabelactivetomod2] = useState("")
 
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")

  const [activefrommain,setactivefrommain] = useState("")
  const [labelactivefrommain,setlabelactivefrommain] = useState("")
  const [borderactivefrommain,setborderactivefrommain] = useState("")

  const [activetomain,setactivetomain] = useState("")
  const [borderactivetomain,setborderactivetomain] = useState("")
  const [labelactivetomain,setlabelactivetomain] = useState("")

  useEffect(()=>{
    var date = moment("2017-07-11")
      var now = moment("2020-07-12");

      if (now > date) {
        console.log("past")
      } else {
        console.log("future")
      }
  },[])
  
  
    const handleactivefrommod1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrommod1(dtfinalc)
        }  
    }
    const handleactivetomod1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivetomod1(dtfinalc)
        }  
    }
    const handleactivefrommod2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrommod2(dtfinalc)
        }  
    }
    const handleactivetomod2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivetomod2(dtfinalc)
        }  
    }
    const handleactivefrommain = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrommain(dtfinalc)
        }  
    }
    const handleactivetomain = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivetomain(dtfinalc)
        }  
    }
   
    
  
 

    const [modalidvalues,setmodalidvalues] = useState({
      menunameval:"",
      urlval:"",
      sequence:""
    })
   
    const [show3, setShow3] = useState(false);
    const [modalitem,setmodalitem] = useState({})
    const handleShow3 = (e,myitem) =>{
      setShow3(true)
      
    };
    const handleClosemenumodal= ()=>{
      setShow3(false)
    }
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(menuApi.data)

  const [menunamemod1,setmenunamemod1] = useState("")
  const [bordermenunamemod1,setbordermenunamemod1] = useState("")
  const [labelmenunamemod1,setlabelmenunamemod1] = useState("")

  const [urlmod1,seturlmod1] = useState("")
  const [borderurlmod1,setborderurlmod1] = useState("")
  const [labelurlmod1,setlabelurlmod1] = useState("")

  const [sequencemod1,setsequencemod1] = useState("")
  const [bordersequencemod1,setbordersequencemod1] = useState("")
  const [labelsequencemod1,setlabelsequencemod1] = useState("")

  const [parentmenumod1,setparentmenumod1] = useState("")
  const [borderparentmenumod1,setborderparentmenumod1] = useState("")
  const [labelparentmenumod1,setlabelparentmenumod1] = useState("")

  
  const [menunamemod2,setmenunamemod2] = useState("")
  const [bordermenunamemod2,setbordermenunamemod2] = useState("")
  const [labelmenunamemod2,setlabelmenunamemod2] = useState("")

  const [urlmod2,seturlmod2] = useState("")
  const [borderurlmod2,setborderurlmod2] = useState("")
  const [labelurlmod2,setlabelurlmod2] = useState("")

  const [sequencemod2,setsequencemod2] = useState("")
  const [bordersequencemod2,setbordersequencemod2] = useState("")
  const [labelsequencemod2,setlabelsequencemod2] = useState("")

  const [parentmenumod2,setparentmenumod2] = useState("")
  const [borderparentmenumod2,setborderparentmenumod2] = useState("")
  const [labelparentmenumod2,setlabelparentmenumod2] = useState("")


  const drpfuncparentmenumod1=(myval,myid)=>{
    setparentmenumod1(myval)
  }
  const drpfuncparentmenumod2=(myval,myid)=>{
    setparentmenumod2(myval)
  }

  const handlesavemod1=()=>{
    validationComp(menunamemod1,setlabelmenunamemod1,setbordermenunamemod1,"Menu Name Required")
    validationComp(urlmod1,setlabelurlmod1,setborderurlmod1,"Url Required")
    validationComp(sequencemod1,setlabelsequencemod1,setbordersequencemod1,"Sequence Required")
    validationDrp(parentmenumod1,setlabelparentmenumod1,setborderparentmenumod1,"Parent Menu Required")
    validationDrp(activefrommod1,setlabelactivefrommod1,setborderactivefrommod1,"Active From Required")
    validationDrp(activetomod1,setlabelactivetomod1,setborderactivetomod1,"Active To Required")
  
  }

  const handlesavemod2=()=>{
    validationComp(menunamemod2,setlabelmenunamemod2,setbordermenunamemod2,"Menu Name Required")
    validationComp(urlmod2,setlabelurlmod2,setborderurlmod2,"Url Required")
    validationComp(sequencemod2,setlabelsequencemod2,setbordersequencemod2,"Sequence Required")
    validationDrp(parentmenumod2,setlabelparentmenumod2,setborderparentmenumod2,"Parent Menu Required")
      validationDrp(activefrommod2,setlabelactivefrommod2,setborderactivefrommod2,"Active From Required")
  validationDrp(activetomod2,setlabelactivetomod2,setborderactivetomod2,"Active To Required")

  }

  const mainfilter = (arr) => {

    setfilteredArr(arr);

  }



  const [tempfilteredarr,settempfilteredarr] = useState([])
  
  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show?show:10)
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show]);
  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
      // Invoke when user click to request another page.
      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % menuApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    useEffect(() => {
        // Fetch items from another resources.
        const endOffset2 = itemOffset2 + itemsPerPage2;        
        setCurrentItemsmodel(menuApi.data.slice(itemOffset2, endOffset2));
        setPageCount2(Math.ceil(menuApi.data.length / itemsPerPage2));
      }, [itemOffset2, itemsPerPage2]);
    
      // Invoke when user click to request another page.
      const handlePageClickmodel = (event) => {
        const newOffset2 = event.selected * itemsPerPage2 % menuApi.data.length;
        
        setpaginatenumselected2(event.selected);
        setItemOffset2(newOffset2);
      };
      const handleClose=()=>{
        setShow2(false)
      }
      const [rolemodalvalue,setrolemodalvalue] = useState("")
      const [rolemodalvalue2,setrolemodalvalue2] = useState("")
      const drpfuncrolemodal=(myid,mystatus)=>{
        setrolemodalvalue(mystatus)
        
          
      }
      const drpfuncrolemodal2=(mystatus,myid)=>{
        setrolemodalvalue2(mystatus)
        console.log("manualselect" , mystatus)
          
      }
      
      const handlesearch =()=>{
    
        
      
    }

    

    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
    const handleModaleditsave=()=>{
      console.log(rolemodalvalue2)
      setShow3(false)
    }

   
   

    useEffect(()=>{
      
        mainfilter(menuApi.data)      

      
    },[])
    
    
    const optionsparentmenu = [
      {
        id:1,
        opt:"Home1"
      },
      {
        id:2,
        opt:"Home2"
      },
    ]
    

  return (
    <>
          <div className="felxvaluecompmbmain">
              <div className="studentdashboardmobilewrapper">
                  <div className="mobilecontainer">
                      <div className="adminmbheading">
                          <h3>Menu</h3>
                      </div>
                      <div className="admbwrap bt0">
                        <Row>
                            <Col xs={12}>
                            <div className="basicinput">
                                
                            <button className='cmbutton' onClick={handleShow}> <AiOutlinePlus/> Add New Menu</button>
                            </div>
                            </Col>
                            <Col xs={6} className="pr5"> 
                            <div className="basicinput h40p">
                                <p>Active From</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap h40">
                                <DatePicker
                                    
                                    value={activefrommod1}
                                    onChange={(newvaldob)=>handleactivefrommain(newvaldob)}
                                    renderInput={(params) => <TextField style={borderactivefrommain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Active From"
                                        }} error={false} />}
                                />
                                <label>{labelactivefrommain}</label>
                                </div>
                                </LocalizationProvider>
                                </div>
                            </Col>
                            <Col xs={6} className='pl5'>
                            <div className="basicinput h40p">
                                <p>Active To</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap h40">
                                <DatePicker
                                    
                                    value={activetomod1}
                                    onChange={(newvaldob)=>handleactivetomain(newvaldob)}
                                    renderInput={(params) => <TextField style={borderactivetomain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Active From"
                                        }} error={false} />}
                                />
                                <label>{labelactivetomain}</label>
                                </div>
                                </LocalizationProvider>
                                </div>
                            </Col>
                        </Row>
                      </div>
                      <div className="admbwrap bt0">
                      <Row>
                    <Col xs={4} className="pr5">
                    <div className="basicinput">
                      <p>Show</p>
                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                      </div>
                      </div>
                    </Col>
                    <Col xs={8} className="pl5">
                            <div className="basicinput">
                              <p >Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                    </Col>
                  </Row>
                      </div>
                      <div className="admbwrap">
                         <div className="tablewrapscroll">
                         <div className="flexvaluetable">
                    <table>
                      <thead>
                        <tr>
                            {
                              menuApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.menuid}</td>
                                  <td>{item.menuname}</td>
                                  <td>{item.url}</td>
                                  <td>{item.sequence}</td>
                                  <td>{item.parentmenu}</td>
                                  <td>{item.activefrom}</td>
                                  <td>{item.activeto}</td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            "hello"
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                         </div>
                      </div>
                      <div className="admbwrap">
                      <Row>
                  <Col xs={12} lg={6} className='text-center'>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {menuApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col xs={12} lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      </div>
                      <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Menu</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <Row>
                   <Col lg={6}>
                   <div className="basicinputfield h40p">
                            <p>Menu Name</p>
                            <div className="inputgap h35">
                              <input style={bordermenunamemod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={menunamemod1} onChange={(e) => setmenunamemod1(e.target.value)} />
                              <label>{labelmenunamemod1}</label>
                            </div>
                          </div>
                      
                    </Col>
                   <Col lg={6} >
                   <div className="basicinputfield h40p">
                            <p>URL</p>
                            <div className="inputgap h35">
                              <input style={borderurlmod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={urlmod1} onChange={(e) => seturlmod1(e.target.value)} />
                              <label>{labelurlmod1}</label>
                            </div>
                          </div>
                    </Col>
                   <Col lg={6}>
                   <div className="basicinputfield h40p">
                            <p>Sequence</p>
                            <div className="inputgap h35">
                              <input style={bordersequencemod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={sequencemod1} onChange={(e) => setsequencemod1(e.target.value)} />
                              <label>{labelsequencemod1}</label>
                            </div>
                          </div>
                      
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                      <p>Parent Menu</p>
                      <div className="inputgap h40">

                      <div className="dropdownwrapper">
                        
                          <Dropdown2 err={borderparentmenumod1} func={drpfuncparentmenumod1} myplaceholder={parentmenumod1} fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsparentmenu}/>
                      </div>
                      <label>{labelparentmenumod1}</label>
                      </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                  
                  <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefrommod1}
                              onChange={(newvaldob)=>handleactivefrommod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefrommod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefrommod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                <Col lg={6}>
                <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetomod1}
                              onChange={(newvaldob)=>handleactivetomod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetomod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivetomod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                   </Row>
                   
                   
                    

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                    <div className="buttonswrap d-flex">

                  <button variant="secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesavemod1}>
                    Save
                  </button>
                    </div>
                </Modal.Footer>
              </Modal>

              {/* modal2ori */}
              <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClosemenumodal} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Menu {modalitem.menuid}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  
                <Row>
                   <Col lg={6}>
                   <div className="basicinputfield h40p">
                            <p>Menu Name</p>
                            <div className="inputgap h35">
                              <input style={bordermenunamemod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={menunamemod2} onChange={(e) => setmenunamemod2(e.target.value)} />
                              <label>{labelmenunamemod2}</label>
                            </div>
                          </div>
                      
                    </Col>
                   <Col lg={6}>
                   <div className="basicinputfield h40p">
                            <p>URL</p>
                            <div className="inputgap h35">
                              <input style={borderurlmod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={urlmod2} onChange={(e) => seturlmod2(e.target.value)} />
                              <label>{labelurlmod2}</label>
                            </div>
                          </div>
                    </Col>
                   <Col lg={6}>
                   <div className="basicinputfield h40p">
                            <p>Sequence</p>
                            <div className="inputgap h35">
                              <input style={bordersequencemod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={sequencemod2} onChange={(e) => setsequencemod2(e.target.value)} />
                              <label>{labelsequencemod2}</label>
                            </div>
                          </div>
                      
                    </Col>
                    <Col lg={6}>
                    <div className="basicinputfield h40p">
                      <p>Parent Menu</p>
                      <div className="inputgap h40">

                      <div className="dropdownwrapper">
                        
                          <Dropdown2 err={borderparentmenumod2} func={drpfuncparentmenumod2} myplaceholder={parentmenumod2} fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsparentmenu}/>
                      </div>
                      <label>{labelparentmenumod2}</label>
                      </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                  
                  <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefrommod2}
                              onChange={(newvaldob)=>handleactivefrommod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefrommod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefrommod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                <Col lg={6}>
                <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetomod2}
                              onChange={(newvaldob)=>handleactivetomod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetomod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivetomod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                   </Row>
                   
                   
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesavemod2}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>
                  </div>
              </div>
          </div>
    </>
  )
}

export default MenuCompmb